import React from "react";
import { Helmet } from "react-helmet";

const Termsandconditions = () => {
  return (
    <>
      <Helmet>
        <title>Terms and Conditions - eYantra</title>
      </Helmet>
      <div class="container my-5">
        <h1 class="text-center texteYantra">Terms & Conditions</h1>
        <p class="text-center">
          Please read the terms and conditions carefully before using
          eYantra.com services.
        </p>

        <h2>Welcome to eYantra.com</h2>
        <p>
          eYantra.com and its business affiliates provide services and products
          to its users in accordance with the following conditions. Please read
          all the terms and conditions carefully.
        </p>

        <p>
          By using the website, you gain access to premium quality corporate
          gifting solutions available for purchase at the stated prices.
          Unauthorized or illegal usage of products is strictly prohibited. You
          must comply with the laws of your jurisdiction when using our products
          and services.
        </p>

        <h2>Electronic Communications</h2>
        <p>
          By visiting eyantra.com or sending emails, you consent to receiving
          electronic communications from us. We may communicate with you via
          email or notices on our website. You agree that all notices,
          agreements, and other communications we provide to you electronically
          fulfill any legal requirement that such communications be in writing.
        </p>

        <h2>Copyright</h2>
        <p>
          eYantra holds exclusive rights to all content on the website,
          including graphics, text, images, logos, audio, video clips, and
          software. The content is solely owned by eYantra.com.
        </p>

        <h2>Trademarks</h2>
        <p>
          eYantra has applied for trademark registration under the Trade and
          Merchandise Act in Hyderabad. We will take legal action if our
          trademarks are violated.
        </p>

        <h2>Promotional Communications</h2>
        <p>
          eYantra reserves the right to send promotional emails, SMS, and make
          calls to registered customers.
        </p>

        <h2>Order Cancellation and Blocking</h2>
        <p>
          eYantra may cancel any order without prior notice. If payment has been
          made, it will be fully refunded. eYantra also reserves the right to
          blacklist or block users for any reason without prior notification.
        </p>

        <h2>General Conditions</h2>
        <p>
          We reserve the right to refuse service to any user at any time for any
          reason. By using the website, you consent to the transfer of your
          content (except credit card information) across different networks for
          technical requirements. Encryption is always used for credit card
          information during transmission.
        </p>

        <h2>Accuracy, Completeness, and Timeliness of Information</h2>
        <p>
          The information provided on the website is for reference purposes
          only. We are not responsible for any inaccuracies in product
          descriptions. We reserve the right to modify website content without
          obligation to update it. It is your responsibility to check for any
          updates or changes to the site.
        </p>

        <h2>Your Account</h2>
        <p>
          You are responsible for maintaining the confidentiality of your
          account information. You agree to restrict access to your computer and
          accept responsibility for any activities under your account. eYantra
          reserves the right to terminate accounts or remove content at its
          discretion.
        </p>

        <h2>Modifications to Service and Prices</h2>
        <p>
          eYantra reserves the right to modify prices for services or products
          at any time without prior notice. Services may be discontinued or
          modified at any time, and eYantra is not liable for such changes or
          suspensions.
        </p>

        <h2>Products</h2>
        <p>
          Some products on eYantra may be exclusively available online. These
          products are subject to exceptions in our return policy. We strive for
          accuracy but cannot guarantee that product descriptions or colors are
          accurate. We reserve the right to stop selling products or limit
          quantities without prior notice.
        </p>

        <h2>Accuracy of Billing and Account Information</h2>
        <p>
          We reserve the right to limit or cancel orders based on
          billing/shipping address or account information. In such cases, we may
          attempt to notify you using the contact details you provided.
        </p>

        <h2>User Comments, Feedback, and Other Submissions</h2>
        <p>
          If you submit creative ideas, proposals, or other materials (whether
          solicited or unsolicited), you agree that eYantra has the right to
          use, edit, or publish your comments without limitation. You are solely
          responsible for the accuracy of your submissions and agree not to
          violate any third-party rights.
        </p>

        <h2>Errors, Inaccuracies, and Omissions</h2>
        <p>
          Occasionally, there may be errors in pricing, descriptions, or
          shipping charges. We reserve the right to correct any errors and
          cancel orders based on inaccurate information.
        </p>

        <h2>License and Site Access</h2>
        <p>
          We grant you limited access to use the site and services. Unauthorized
          use or reproduction of content is prohibited. Any breach of these
          terms will result in termination of your access to the site.
        </p>

        <h2>Disclaimer of Warranties; Limitation of Liability</h2>
        <p>
          We do not guarantee that your use of our services will be
          uninterrupted, error-free, or secure. Products and services are
          provided "as-is" without warranties of any kind. We are not liable for
          any damages resulting from the use of the services or products, even
          if we were informed of the possibility of such damages.
        </p>

        <h2>Indemnification</h2>
        <p>
          You agree to indemnify eYantra, its affiliates, officers, and
          employees against any claims, damages, or costs arising from your
          breach of these terms or any violation of law or third-party rights.
        </p>

        <h2>Severability</h2>
        <p>
          If any part of these terms is deemed invalid or unenforceable, the
          rest of the terms will remain in full force and effect.
        </p>

        <h2>Termination</h2>
        <p>
          We may terminate these terms at any time without notice if we believe
          you have violated them. You may terminate your account by notifying us
          that you no longer wish to use our services.
        </p>

        <h2>Entire Agreement</h2>
        <p>
          These terms constitute the entire agreement between you and eYantra
          and supersede any prior agreements. Failure to enforce any provision
          does not constitute a waiver.
        </p>

        <h2>Governing Law</h2>
        <p>These terms are governed by the laws of India.</p>

        <h2>Changes to Terms of Service</h2>
        <p>
          eYantra reserves the right to update or change these terms at any
          time. You are responsible for reviewing these terms regularly.
          Continued use of the site after changes implies acceptance of the new
          terms.
        </p>

        <h2>Contact Information</h2>
        <p>
          If you have any questions or concerns about these Terms of Service,
          please contact us at{" "}
          <a href="mailto:info@eYantra.com">info@eYantra.com</a>.
        </p>
      </div>
    </>
  );
};

export default Termsandconditions;
